import { Link } from '@tanstack/react-router'
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react'

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white relative py-8 md:text-left text-center">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4 md:text-left text-center flex flex-col md:items-start items-center">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">P</span>
              </div>
              <span className="text-xl font-bold">PhilTrade</span>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              The premier platform for wedding supplier exhibits in the Philippines. 
              Connecting suppliers with celebrants through professional showcases and networking events.
            </p>
            <div className="flex space-x-4 md:justify-start justify-center">
              <a href="#" className="text-gray-400 hover:text-primary-500 transition-colors duration-200">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-primary-500 transition-colors duration-200">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-primary-500 transition-colors duration-200">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-primary-500 transition-colors duration-200">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/" 
                  className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/events" 
                  className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm"
                >
                  Exhibits
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm">
                  About Us
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Exhibit Categories */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Exhibit Types</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm">
                  Garden Wedding Exhibits
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm">
                  Beach Wedding Exhibits
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm">
                  Traditional Wedding Exhibits
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm">
                  Luxury Wedding Exhibits
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm">
                  Supplier Showcases
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Contact Information</h3>
            <div className="space-y-3 text-center md:text-left">
              <div className="flex flex-col md:flex-row md:items-center md:space-x-3 items-center">
                <Mail size={16} className="text-secondary-500 mb-1 md:mb-0" />
                <span className="text-gray-300 text-sm">info@philtrade.com</span>
              </div>
              <div className="flex flex-col md:flex-row md:items-center md:space-x-3 items-center">
                <Phone size={16} className="text-secondary-500 mb-1 md:mb-0" />
                <span className="text-gray-300 text-sm">+63 2 1234 5678</span>
              </div>
              <div className="flex flex-col md:flex-row md:items-start md:space-x-3 items-center">
                <MapPin size={16} className="text-secondary-500 mt-1 md:mt-0" />
                <span className="text-gray-300 text-sm">
                  Makati City, Metro Manila<br />
                  Philippines
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Powered by Evently Section */}
        <div className="mt-8 flex flex-col items-center justify-center">
          <div className="rounded-xl px-8 py-5 flex flex-col items-center w-full max-w-xs">
            <span className="uppercase tracking-widest text-xs text-primary-100 font-semibold mb-2">
              Powered by
            </span>
            <a
              href="https://evently.ph"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center group"
            >
              <img
                src="/assets/images/partners/evently.png"
                alt="Evently"
                className="w-14 h-14 mb-2 rounded-full border-2 border-primary-200 shadow-md group-hover:scale-105 transition-transform duration-200 bg-white"
                style={{ background: 'white' }}
              />
              <span className="text-primary-100 text-base font-bold group-hover:text-yellow-300 transition-colors duration-200">
                Evently
              </span>
            </a>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © {new Date().getFullYear()} PhilTrade. All rights reserved. Premier wedding supplier exhibit platform.
            </div>
            <div className="flex space-x-6">
              <a href="#" className="text-gray-400 hover:text-primary-500 transition-colors duration-200 text-sm">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-primary-500 transition-colors duration-200 text-sm">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-primary-500 transition-colors duration-200 text-sm">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
